const qwLogin = {
  state: {
    //企业基本信息
    companyInfo: {
      corp_info: {},
      user_info: {}
    },
    //企业配置项
    config: {
      is_show: true,
      corpid: '',
      //备注: 应用的信息配置
      app: {
        appid: '',
        agent_id: '',
        secret: '',
        token: '',
        aes_key: ''
      },
      //备注: 外部联系人管理的信息配置
      external_contact: {
        secret: '',
        token: '',
        aes_key: ''
      },
      //备注: 通讯录的信息配置
      contacts: {
        secret: '',
        token: '',
        aes_key: ''
      }
    }
  },
  mutations: {
    //设置企业基本信息
    SETCompanyInfo: (state, payload) => {
      console.log('设置企业基本信息', payload)
      state.companyInfo = payload
    },
    //设置企业配置信息
    SETCompanyConifg: (state, payload) => {
      state.config[payload.key] = payload.val
    }
  },
  actions: {},
  getters: {
    //获取企微信息
    companyInfo (state) {
      return state.companyInfo
    },
    //获取企微配置信息
    companyConfig (state) {
      return state.config
    }
  }
}

export default qwLogin
